module.exports = __webpack_public_path__ + "img/not_retweet_icon.35db9a56.png";